import { ArrayLimitToPipe } from '../../filters/array-limit-to.pipe';
import { ButtonConversationsComponent } from '../../components/button-conversations/button-conversations.component';
import { ItemConversationComponent } from '../../components/item-conversation/item-conversation.component';
import { Component, OnInit, inject, OnDestroy, ChangeDetectorRef } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormsModule } from '@angular/forms';
import Config from '../../utils/config.service';
import AngularHelperService from '../../services/angular-helper.service';
import AngularBroadcastHelperService from '../../services/angular-broadcast-helper.service';
import $ from 'jquery';
import { Subscription } from 'rxjs';

@Component({
	standalone: true,
	selector: 'list-conversations',
	templateUrl: './list-conversations.component.html',
	imports: [ CommonModule, ArrayLimitToPipe, ButtonConversationsComponent, ItemConversationComponent, FormsModule ]
})
export class ListConversationsComponent implements OnInit, OnDestroy {
	private config: Config = inject(Config);
	private angularHelperService: AngularHelperService = inject(AngularHelperService);
	private angularBroadcastHelperService: AngularBroadcastHelperService = inject(AngularBroadcastHelperService);
	
	vm: any = undefined;
	broadcastSubscriptions: Array<Subscription> = [];
	
	constructor(private cdr: ChangeDetectorRef) {
		this.vm = this;
	}
	
	ngOnInit() {
		this.vm.chats = [];
		this.vm.conversationWidth = 310;
		this.vm.sidebarWidth = 17;
		this.vm.moreButtonWidth = 200;
		this.vm.limit = 2;
		
		$(window).on('resize.limit', () => { this.updateLimit(); });
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this,
				this.config.getBroadcastConfig().Session.LOGOUT, () => { this.vm.chats = []; })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onEvent(this,
				this.config.getBroadcastConfig().Chat.CLOSE, (e, chat) => { this.closeChat(e, chat); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Chat.OPEN,
				(e, chat) => { this.openChat(e, chat); })
		);
		this.broadcastSubscriptions.push(
			this.angularBroadcastHelperService.onRootEvent(this.config.getBroadcastConfig().Session.CONTACT_REMOVED,
				(e, user) => { this.removeContact(e, user); })
		);
	}
	
	ngOnDestroy() {
		$(window).off('resize.limit');
		for (var b = 0; b < this.broadcastSubscriptions.length; b++) {
			this.broadcastSubscriptions[b].unsubscribe();
		}
	}
	
	openChat(e, chat) {
		this.updateLimit();
		var activeChatIndex: any = this.findActiveChatIndex('id', chat.id);
		if (activeChatIndex === null) {
			activeChatIndex = this.findActiveChatIndex('privateChatFriend.id', chat.privateChatFriend.id);
			if (activeChatIndex === null) {
				this.vm.chats.unshift(chat);
			}
		}
		this.cdr.detectChanges();
	}
	
	closeChat(event, chat) {
		var chatIndex: any = chat.localId ? this.findActiveChatIndex('localId', chat.localId) : this.findActiveChatIndex('id', chat.id);
		if (chatIndex !== null) {
			this.vm.chats.splice(chatIndex, 1);
		}
		this.cdr.detectChanges();
	}
	
	findActiveChatIndex(key, value) {
		var index: any = null;
		if (value) {
			for(var i = 0; i < this.vm.chats.length; i++) {
				var chat = this.vm.chats[i];
				if (key.indexOf('.') > 0) {
					var parts = key.split('.');
					if (chat[parts[0]][parts[1]] === value) {
						index = i;
					}
				} else if (chat[key] === value) {
					index = i;
				}
			}
		}
		
		return index;
	}
	
	updateLimit() {
		var windowWidth: any = this.angularHelperService.getWindow().innerWidth;
		this.vm.limit = Math.max(1, Math.floor((windowWidth - this.vm.moreButtonWidth - this.vm.sidebarWidth) / this.vm.conversationWidth));
	}
	
	removeContact(e, user) {
		this.angularHelperService.forEach(this.vm.chats, (chat, index) => {
			if (chat.privateChatFriend.id === user.id) {
				this.vm.chats.splice(index, 1);
				this.angularBroadcastHelperService.rootEmit(this.config.getBroadcastConfig().Chat.DESTROY, chat);
			}
		});
	}
	
}